export default {
  root: ({ props, context, parent }) => ({
    class: [
      'relative',

      // Alignments
      'items-center inline-flex text-center align-bottom justify-center',

      // Sizes & Spacing
      {
        'text-sm': props.size === 'small',
        'w-6 p-1': props.label == null && props.size === 'small',
        'px-3 py-1': props.label !== null && props.size === 'small'
      },
      {
        'w-9 p-2': props.label == null && props.size === null,
        'px-5 py-2': props.label !== null && props.size === null
      },

      {
        'text-lg-button': props.size === 'large',
        'w-12 p-3': props.label == null && props.size === 'large',
        'px-6 py-3': props.label !== null && props.size === 'large'
      },
      // Shapes
      { 'shadow-medium-dark hover:shadow-small-dark-hover': props.raised },
      { 'rounded-md': !props.rounded, 'rounded-full': props.rounded },
      { 'rounded-none first:rounded-l-md last:rounded-r-md': parent.instance.$name == 'InputGroup' },

      // Link Button
      { 'text-primary-600 bg-transparent border-transparent': props.link },

      // Plain Button
      { 'text-white bg-gray-500 border border-gray-500': props.plain && !props.outlined && !props.text },
      // Plain Text Button
      { 'text-secondary-500': props.plain && props.text },
      // Plain Outlined Button
      { 'text-secondary-500 border border-gray-500': props.plain && props.outlined },

      // Text Button
      { 'bg-transparent border-transparent': props.text && !props.plain },

      // Outlined Button
      { 'bg-transparent border': props.outlined && !props.plain },

      // --- Severity Buttons ---

      // Primary Button
      {
        'text-white dark:text-secondary-900':
          !props.link && props.severity === null && !props.text && !props.outlined && !props.plain,
        'bg-primary-500 dark:bg-primary-400':
          !props.link && props.severity === null && !props.text && !props.outlined && !props.plain,
        'border border-primary-500 dark:border-primary-400':
          !props.link && props.severity === null && !props.text && !props.outlined && !props.plain
      },
      // Primary Text Button
      { 'text-primary-500 dark:text-primary-400': props.text && props.severity === null && !props.plain },
      // Primary Outlined Button
      {
        'text-primary-500 border border-primary-500 bg-white hover:bg-white':
          props.outlined && props.severity === null && !props.plain
      },

      // Secondary Button
      {
        'text-white dark:text-secondary-900':
          props.severity === 'secondary' && !props.text && !props.outlined && !props.plain,
        'bg-secondary-500 dark:bg-secondary-400':
          props.severity === 'secondary' && !props.text && !props.outlined && !props.plain,
        'border border-secondary-500 dark:border-secondary-400':
          props.severity === 'secondary' && !props.text && !props.outlined && !props.plain
      },
      // Secondary Text Button
      { 'text-secondary-500 dark:text-secondary-300': props.text && props.severity === 'secondary' && !props.plain },
      // Secondary Outlined Button
      {
        'text-secondary-500 dark:text-secondary-300 border border-secondary-500 hover:bg-secondary-300/20':
          props.outlined && props.severity === 'secondary' && !props.plain
      },

      // Success Button
      {
        'text-white dark:text-green-900':
          props.severity === 'success' && !props.text && !props.outlined && !props.plain,
        'bg-green-500 dark:bg-green-400':
          props.severity === 'success' && !props.text && !props.outlined && !props.plain,
        'border border-green-500 dark:border-green-400':
          props.severity === 'success' && !props.text && !props.outlined && !props.plain
      },
      // Success Text Button
      { 'text-green-500 dark:text-green-400': props.text && props.severity === 'success' && !props.plain },
      // Success Outlined Button
      {
        'text-green-500 border border-green-500 hover:bg-green-300/20':
          props.outlined && props.severity === 'success' && !props.plain
      },

      // Info Button
      {
        'text-white dark:text-secondary-900':
          props.severity === 'info' && !props.text && !props.outlined && !props.plain,
        'bg-info-500 dark:bg-info-400': props.severity === 'info' && !props.text && !props.outlined && !props.plain,
        'border border-info-500 dark:border-info-400':
          props.severity === 'info' && !props.text && !props.outlined && !props.plain
      },
      // Info Text Button
      { 'text-info-500 dark:text-info-400': props.text && props.severity === 'info' && !props.plain },
      // Info Outlined Button
      {
        'text-info-500 border border-info-500 hover:bg-info-300/20 ':
          props.outlined && props.severity === 'info' && !props.plain
      },

      // Warning Button
      {
        'text-white dark:text-secondary-900':
          props.severity === 'warning' && !props.text && !props.outlined && !props.plain,
        'bg-warning-500 dark:bg-warning-400':
          props.severity === 'warning' && !props.text && !props.outlined && !props.plain,
        'border border-warning-500 dark:border-warning-400':
          props.severity === 'warning' && !props.text && !props.outlined && !props.plain
      },
      // Warning Text Button
      { 'text-warning-500 dark:text-warning-400': props.text && props.severity === 'warning' && !props.plain },
      // Warning Outlined Button
      {
        'text-warning-500 border border-warning-500 hover:bg-warning-300/20':
          props.outlined && props.severity === 'warning' && !props.plain
      },

      // Help Button
      {
        'text-white dark:text-secondary-900':
          props.severity === 'help' && !props.text && !props.outlined && !props.plain,
        'bg-purple-500 dark:bg-purple-400': props.severity === 'help' && !props.text && !props.outlined && !props.plain,
        'border border-purple-500 dark:border-purple-400':
          props.severity === 'help' && !props.text && !props.outlined && !props.plain
      },
      // Help Text Button
      { 'text-purple-500 dark:text-purple-400': props.text && props.severity === 'help' && !props.plain },
      // Help Outlined Button
      {
        'text-purple-500 border border-purple-500 hover:bg-purple-300/20':
          props.outlined && props.severity === 'help' && !props.plain
      },

      // Danger Button
      {
        'text-white dark:text-secondary-900':
          props.severity === 'danger' && !props.text && !props.outlined && !props.plain,
        'bg-danger-500 dark:bg-danger-400':
          props.severity === 'danger' && !props.text && !props.outlined && !props.plain,
        'border border-danger-500 dark:border-danger-400':
          props.severity === 'danger' && !props.text && !props.outlined && !props.plain
      },
      // Danger Text Button
      { 'text-danger-500 dark:text-danger-400': props.text && props.severity === 'danger' && !props.plain },
      // Danger Outlined Button
      {
        'text-danger-500 border border-danger-500 hover:bg-danger-300/20':
          props.outlined && props.severity === 'danger' && !props.plain
      },

      // --- Severity Button States ---
      'focus:outline-none focus:outline-offset-0 focus:ring',

      // Link
      { 'focus:ring-primary-400/50 dark:focus:ring-primary-300/50': props.link },

      // Plain
      { 'hover:bg-gray-600 hover:border-gray-600': props.plain && !props.outlined && !props.text },
      // Text & Outlined Button
      { 'hover:bg-secondary-300/20': props.plain && (props.text || props.outlined) },

      // Primary
      {
        'hover:bg-primary-600 dark:hover:bg-primary-300 hover:border-primary-600 dark:hover:border-primary-300':
          !props.link && props.severity === null && !props.text && !props.outlined && !props.plain
      },
      { 'focus:ring-primary-400/50 dark:focus:ring-primary-300/50': props.severity === null },
      // Text & Outlined Button
      { 'hover:bg-white': (props.text || props.outlined) && props.severity === null && !props.plain },

      // Secondary
      {
        'hover:bg-secondary-600 dark:hover:bg-secondary-300 hover:border-secondary-600 dark:hover:border-secondary-300':
          props.severity === 'secondary' && !props.text && !props.outlined && !props.plain
      },
      { 'focus:ring-secondary-400/50 dark:focus:ring-secondary-300/50': props.severity === 'secondary' },
      // Text & Outlined Button
      { 'hover:bg-secondary-300/20': (props.text || props.outlined) && props.severity === 'secondary' && !props.plain },

      // Success
      {
        'hover:bg-green-600 dark:hover:bg-green-300 hover:border-green-600 dark:hover:border-green-300':
          props.severity === 'success' && !props.text && !props.outlined && !props.plain
      },
      { 'focus:ring-green-400/50 dark:focus:ring-green-300/50': props.severity === 'success' },
      // Text & Outlined Button
      { 'hover:bg-green-300/20': (props.text || props.outlined) && props.severity === 'success' && !props.plain },

      // Info
      {
        'hover:bg-info-600 dark:hover:bg-info-300 hover:border-info-600 dark:hover:border-info-300':
          props.severity === 'info' && !props.text && !props.outlined && !props.plain
      },
      { 'focus:ring-info-400/50 dark:focus:ring-info-300/50': props.severity === 'info' },
      // Text & Outlined Button
      { 'hover:bg-info-300/20': (props.text || props.outlined) && props.severity === 'info' && !props.plain },

      // Warning
      {
        'hover:bg-warning-600 dark:hover:bg-warning-300 hover:border-warning-600 dark:hover:border-warning-300':
          props.severity === 'warning' && !props.text && !props.outlined && !props.plain
      },
      { 'focus:ring-warning-400/50 dark:focus:ring-warning-300/50': props.severity === 'warning' },
      // Text & Outlined Button
      { 'hover:bg-warning-300/20': (props.text || props.outlined) && props.severity === 'warning' && !props.plain },

      // Help
      {
        'hover:bg-purple-600 dark:hover:bg-purple-300 hover:border-purple-600 dark:hover:border-purple-300':
          props.severity === 'help' && !props.text && !props.outlined && !props.plain
      },
      { 'focus:ring-purple-400/50 dark:focus:ring-purple-300/50': props.severity === 'help' },
      // Text & Outlined Button
      { 'hover:bg-purple-300/20': (props.text || props.outlined) && props.severity === 'help' && !props.plain },

      // Danger
      {
        'hover:bg-danger-600 dark:hover:bg-danger-300 hover:border-danger-600 dark:hover:border-danger-300':
          props.severity === 'danger' && !props.text && !props.outlined && !props.plain
      },
      { 'focus:ring-danger-400/50 dark:focus:ring-danger-300/50': props.severity === 'danger' },
      // Text & Outlined Button
      { 'hover:bg-danger-300/20': (props.text || props.outlined) && props.severity === 'danger' && !props.plain },

      // Disabled
      { 'opacity-60 pointer-events-none cursor-default': context.disabled },

      // Transitions
      'transition duration-200 ease-in-out',

      // Misc
      'cursor-pointer overflow-hidden select-none'
    ]
  }),
  label: ({ props }) => ({
    class: [
      'duration-200',
      'font-bold',
      {
        'hover:underline': props.link
      },
      { 'flex-1': props.label !== null, 'invisible w-0': props.label == null }
    ]
  }),
  icon: ({ props }) => ({
    class: [
      'mx-0',
      {
        'mr-2': props.iconPos == 'left' && props.label != null,
        'ml-2 order-1': props.iconPos == 'right' && props.label != null,
        'mb-2': props.iconPos == 'top' && props.label != null,
        'mt-2': props.iconPos == 'bottom' && props.label != null
      }
    ]
  }),
  loadingicon: ({ props }) => ({
    class: [
      'h-4 w-4',
      'mx-0',
      {
        'mr-2': props.iconPos == 'left' && props.label != null,
        'ml-2 order-1': props.iconPos == 'right' && props.label != null,
        'mb-2': props.iconPos == 'top' && props.label != null,
        'mt-2': props.iconPos == 'bottom' && props.label != null
      },
      'animate-spin'
    ]
  }),
  badge: ({ props }) => ({
    class: [{ 'ml-2 w-4 h-4 leading-none flex items-center justify-center': props.badge }]
  })
};
